var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"text-body-1 font-weight-bold"},[_vm._v("Please do not back and refresh the page. Redirecting ...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }